export const RECAPTCHA_TOKEN = process.env.REACT_APP_RECAPTCHA_TOKEN;
export const WEB_SERVICES = process.env.REACT_APP_WEB_SERVICES;
export const TINY_APP = process.env.REACT_APP_TINY_APP;